import { Popover } from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks/store";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import Button from "components/common/Button";
import {
  setAllCartData,
  setUserData,
  toggleUserDetailModel,
} from "store/slices/main.slice";

type Props = {};

const LoginButton = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [showPopup, setshowPopup] = useState(null);
  const userData = useAppSelector(({ main }) => main.userData);
  const id = showPopup ? "simple-popover" : undefined;
  const menuItemClass =
    "group flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-[14px] font-semibold text-[#344054] transition-colors hover:bg-red-50 hover:text-primary";

  return (
    <div>
      <Button
        aria-describedby={id}
        className="relative flex items-center gap-1.5 !rounded-full bg-white !px-2.5 !py-2 !text-[#111827] shadow-sm ring-1 ring-black/10 transition hover:shadow-md sm:!px-3"
        onClick={(event: any) => {
          if (userData) {
            setshowPopup(event.currentTarget);
          } else {
            navigate("/login");
          }
        }}
      >
        {userData ? (
          <>
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#f3f4f6] text-[#111827]">
              <PersonIcon className="!text-[17px]" />
            </span>
            <span className="max-w-[110px] truncate text-[14px] font-semibold">
              {userData.firstName}
            </span>
            <KeyboardArrowDownRoundedIcon
              className={`!text-[18px] text-[#667085] transition-transform ${
                showPopup ? "rotate-180" : ""
              }`}
            />
          </>
        ) : (
          "Sign In"
        )}
      </Button>
      <Popover
        id={id}
        open={!!showPopup}
        anchorEl={showPopup}
        onClose={() => setshowPopup(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          className: "!mt-2 !rounded-2xl !shadow-[0_18px_44px_rgba(15,23,42,0.18)] !ring-1 !ring-black/5",
        }}
      >
        <div className="w-[220px] bg-white p-2">
          <button
            type="button"
            className={menuItemClass}
            onClick={() => {
              setshowPopup(null);
              navigate("/myOrders");
            }}
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f8fafc] text-[#475467] transition-colors group-hover:bg-white group-hover:text-primary">
              <ReceiptLongOutlinedIcon className="!text-[18px]" />
            </span>
            My Orders
          </button>
          <button
            type="button"
            className={menuItemClass}
            onClick={() => {
              dispatch(toggleUserDetailModel());
              setshowPopup(null);
            }}
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#f8fafc] text-[#475467] transition-colors group-hover:bg-white group-hover:text-primary">
              <ManageAccountsOutlinedIcon className="!text-[18px]" />
            </span>
            Your Profile
          </button>
          <div className="my-1 border-t border-[#eaecf0]" />
          <button
            type="button"
            className="group flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-[14px] font-semibold text-[#b42318] transition-colors hover:bg-red-50"
            onClick={() => {
              dispatch(setUserData(undefined));
              dispatch(setAllCartData([]));
              setshowPopup(null);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }}
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-50 text-primary transition-colors group-hover:bg-white">
              <LogoutOutlinedIcon className="!text-[18px]" />
            </span>
            Sign Out
          </button>
        </div>
      </Popover>
    </div>
  );
};

export default LoginButton;
